import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserContext } from '@vp/ubik-context';
import { availableBNILocales, sanitiseLocale } from '../../i18n/config';
import updateSearchParams from '../../utils/updateSearchParams';
import BusinessNameResults from './components/BusinessNameResults/BusinessNameResults';
import { IndustryBusinessNameIdeasData } from './components/content/explore-business-ideas-data';
import ExploreIdeas from './components/ExploreIdeas/ExploreIdeas';
import GoogleWorkspaceBanner from './components/GoogleWorkspaceBanner/GoogleWorkspaceBanner';
import Hero from './components/Hero/Hero';
import HowItWorks from './components/HowItWorks/HowItWorks';

interface BusinessNameGeneratorPageProps {
    industryBusinessNameIdeasData: IndustryBusinessNameIdeasData;
}

const BusinessNameGeneratorPage = ({
    industryBusinessNameIdeasData,
}: BusinessNameGeneratorPageProps) => {
    const userContext = useUserContext();
    const searchParam = userContext.queryStrings?.search || '';
    const { i18n } = useTranslation();
    const locale = sanitiseLocale(i18n.language);
    const [showResultsPage, setShowResultsPage] = useState<boolean>(searchParam !== '');
    const [inputKeyword, setInputKeyword] = useState<string>(searchParam);

    const handleSubmit = () => {
        setShowResultsPage(true);
        updateSearchParams(inputKeyword.trim());
    };

    return showResultsPage ? (
        <BusinessNameResults inputKeyword={inputKeyword} />
    ) : (
        <>
            <Hero
                onSubmit={() => handleSubmit()}
                inputKeyword={inputKeyword}
                onSearchInputChange={(value) => setInputKeyword(value)}
            />
            {availableBNILocales.includes(locale) && (
                <ExploreIdeas industryBusinessNameIdeasData={industryBusinessNameIdeasData} />
            )}
            <HowItWorks />
            <GoogleWorkspaceBanner />
        </>
    );
};

export default BusinessNameGeneratorPage;
